module.exports = require('./BrowserBanner');
